import React, {useState, useEffect} from 'react'
import { AppBar, Button, Container, Grid, Grow, Paper, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import  { MuiChipsInput } from 'mui-chips-input';

import Pagination from '../Pagination';
import Posts from '../Posts/Posts';
import Form from '../Form/Form';
import getPosts from '../../actions/posts';
import { getPostsBySearch } from '../../actions/posts';
import useStyles from './styles';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Home = () => {
    const [currentId, setCurrentId] = useState(0);
    const dispatch = useDispatch();
    const query = useQuery();
    const navigate = useNavigate();
    const page = query.get('page') || 1;
    const searchQuery = query.get('searchQuery');
    const classes = useStyles();
    const [search, setSearch] = useState('');
    const [tags, setTags] = useState([]);

    const searchPost = () => {
      if(search.trim() || tags) {
        dispatch(getPostsBySearch({search, tags: tags.join(',')}))
        navigate(`/posts/search?searchQuery=${search || 'none'}&tags=${tags.join(',')}`)
      } else {
        navigate('/');
      }
    }

    const handleKeyPress = (e) => {
      if(e.keyCode === 13) {
        searchPost();
      }
    }

    const handleAdd = (tag) => setTags([...tags, tag]);
    const handleDelete = (tagToDelete) => setTags(tags.filter((tag) => tag !== tagToDelete));

  return (
    <>
        <Grow in>
            <Container maxWidth='xl'> 
                <Grid container sx={{justifyContent:"space-between"}} alignItems="stretch" spacing={3} className={classes.gridContainer}>
                <Grid item xs={12} sm={6} md={9}>
                    <Posts setCurrentId={setCurrentId} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <AppBar className={classes.appBarSearch} position="static" color="inherit">
                    <TextField 
                      name='search'
                      variant='outlined'
                      label="Search Favorite Anime"
                      onKeyPress={handleKeyPress}
                      fullWidth
                      value={search}
                      onChange={(e) => setSearch(e.target.value)} 
                    />
                    <MuiChipsInput 
                      style={{margin: '10px 0'}}
                      value={tags}
                      onAddChip={handleAdd}
                      onDeleteChip={handleDelete}
                      label="Search Tags"
                      variant="outlined"
                    />
                    <Button onClick={searchPost} className={classes.searchButton} variant='contained' color="primary">Search</Button>
                  </AppBar>
                    <Form currentId={currentId} setCurrentId={setCurrentId} />
                    {(!searchQuery && !tags.length) && (
                    <Paper elevation={6} className={classes.pagination}>
                      <Pagination page={page}  />
                    </Paper>
                    )}
                </Grid>
                </Grid>
            </Container>
        </Grow> 
    </>
  )
}

export default Home
